import type { SVGProps } from 'react';

export const SvgIconCategory230 = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={33} height={33} viewBox="0 0 33 33" fill="none" {...props}>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.625 25.043a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M23.625 25.043a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M13.125 20.043h6"
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.125 20.543v-11.5a2.987 2.987 0 0 1 3-3M25.125 6.043a2.99 2.99 0 0 1 3 3v11.5"
    />
  </svg>
);
